import { LoaderFunction, redirect, useLoaderData, useNavigate, useParams } from 'react-router-dom';
import isLogin from '../../../utils/isLogin';
import NotFound from '../../NotFound';
import { useState } from "react";
import ConfigElement from '../../../components/config';
import StatusList from '../../../utils/status';
import config from "../../../config";

import axios from 'axios';


const Paint = () => {
    const data = useLoaderData() as ({ paint: TPaint, user: User, token: string } | null);
    const paintData = data?.paint;
    const [submit, setSubmit] = useState(false);
    const [paint, setPaint] = useState(paintData);

    const [showConfig, setShowConfig] = useState(false);
    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loader, setLoader] = useState(false);
    const { paintId } = useParams();

    const navigate = useNavigate();
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoader(true)
        if (!data) return;
        const { user } = data;

        if (!paint || !user) {
            window.scrollTo(0, 0);
            return setMessage('error ot find user or paint');
        }
        try {
            const { data }: { data: { code: number, message: string } } = await axios.post(`${config.api_server_uri}/admin/paint/edit/${paintId}`, paint, { headers: { authorization: user.token } });
            setSubmit(false);
            setLoader(false)

            setMessage(data.message);
            window.scrollTo(0, 0);
        } catch (err) {
            console.log(err);

            setLoader(false)

            setError('error to send data to server')
        }
    };

    return (
        <div>
            {paint ?
                <div className="h-screen w-screen dark:bg-gray-800">
                    <form
                        className='h-auto w-screen dark:bg-gray-800'
                        onSubmit={handleSubmit}>
                        {message ?
                            <div className="h-10 w-full flex items-center justify-center dark:text-white pt-16 flex-col">
                                <div className="w-full sm:w-1/2">
                                    <div id="alert-border-3" className="flex p-4 mb-4 text-green-800 border-t-4 border-green-300 bg-green-50 dark:text-green-400 dark:bg-gray-900 dark:border-green-800 rounded-xl">
                                        <svg className="flex-shrink-0 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>
                                        <div className="ml-3 text-sm font-medium">
                                            {message}
                                        </div>
                                        <button
                                            type="button"
                                            className="ml-auto -mx-1.5 -my-1.5 bg-green-50 text-green-500 rounded-lg focus:ring-2 focus:ring-green-400 p-1.5 hover:bg-green-200 inline-flex h-8 w-8 dark:bg-gray-800 dark:text-green-400 dark:hover:bg-gray-700"
                                            onClick={() => { setError(null); setMessage(null) }}
                                        >
                                            <span className="sr-only">Dismiss</span>
                                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                        }
                        {error ?
                            <div className="h-10 w-full flex items-center justify-center dark:text-white pt-16 flex-col">
                                <div className="w-full sm:w-1/2">
                                    <div id="alert-border-3" className="flex p-4 mb-4 text-red-800 border-t-4 border-red-300 bg-red-50 dark:text-red-400 dark:bg-red-900 dark:border-red-800 rounded-xl">
                                        <svg className="flex-shrink-0 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>
                                        <div className="ml-3 text-sm font-medium">
                                            {error}
                                        </div>
                                        <button
                                            type="button"
                                            className="ml-auto -mx-1.5 -my-1.5 bg-green-50 text-green-500 rounded-lg focus:ring-2 focus:ring-green-400 p-1.5 hover:bg-green-200 inline-flex h-8 w-8 dark:bg-gray-800 dark:text-green-400 dark:hover:bg-gray-700"
                                            onClick={() => { setError(null); setMessage(null) }}
                                        >
                                            <span className="sr-only">Dismiss</span>
                                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                        }
                        {
                            submit ?
                                <div className="h-10 fixed top-28 right-8 z-40">
                                    {loader ? <div role="status" className=' flex w-20 h-20 justify-center items-center'>
                                        <svg className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                        </svg>
                                        <span className="sr-only">Loading...</span>
                                    </div> :
                                        <button
                                            type="submit"
                                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                                            edit plan
                                        </button>}

                                </div> : null
                        }
                        <div className="absolute top-0 right-0 w-36 h-36 flex items-center justify-center z-30">
                            <div className='flex items-center justify-center '>
                                <div className="m-5">
                                    <div className="flex p-2.5 transition-all duration-300 text-white rounded-xl bg-gray-800 hover:bg-gray-700 cursor-pointer" onClick={() => navigate(-1)}>
                                        <svg className="h-10 w-10" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="h-auto w-full flex items-center justify-center dark:text-white pt-16 flex-col">
                            <div className="inline-block align-bottom bg-white dark:bg-gray-800 text-left overflow-hidden shadow transform transition-all sm:w-1/2 rounded-none sm:rounded-lg w-full">
                                <div className="bg-white p-5 dark:bg-gray-900 ">
                                    <div className="sm:flex sm:items-start ">
                                        <div className="text-center sm:mt-0 sm:ml-2 sm:text-left w-full">
                                            <h3 className="text-sm leading-6 font-medium text-gray-400">name</h3>
                                            <input className="text-2xl font-bold text-black dark:text-white dark:bg-gray-800 rounded-lg px-1 w-full"
                                                value={paint.name}
                                                onChange={(event) => {
                                                    setPaint({ ...paint, name: event.target.value })
                                                    setSubmit(true);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inline-block align-bottom bg-white dark:bg-gray-800 text-left overflow-hidden shadow transform transition-all w-full sm:w-1/2 sm:mt-3 rounded-none sm:rounded-lg">
                                <div className="bg-white p-5 dark:bg-gray-900">
                                    <div className="sm:flex sm:items-start">
                                        <div className="text-center sm:mt-0 sm:ml-2 sm:text-left w-full">
                                            <h3 className="text-sm leading-6 font-medium text-gray-400">statue</h3>
                                            <select
                                                value={paint.statue}
                                                className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                                                onChange={(event) => {
                                                    if (StatusList.some((status) => event.target.value === status)) {
                                                        setPaint({
                                                            ...paint,
                                                            statue: event.target.value as any
                                                        });
                                                        setSubmit(true);
                                                    }
                                                }}
                                            >
                                                {StatusList.map((status, index) => <option key={index} value={status}>{status}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inline-block align-bottom bg-white dark:bg-gray-800 text-left overflow-hidden shadow transform transition-all w-full sm:w-1/2 sm:mt-3 rounded-none sm:rounded-lg">
                                <div className="bg-white p-5 dark:bg-gray-900">
                                    <div className="sm:flex sm:items-start">
                                        <div className="text-center sm:mt-0 sm:ml-2 sm:text-left w-full">
                                            <h3 className="text-sm leading-6 font-medium text-gray-400">config</h3>
                                            {showConfig ?
                                                <ConfigElement config={paint.config} handleConfigChangle={(config) => {
                                                    setPaint({ ...paint, config })

                                                }} setSubmit={setSubmit} /> : null
                                            }
                                            <div className="w-full flex justify-center items-center">
                                                <button
                                                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                                                    type="button"
                                                    onClick={(event) => {
                                                        setShowConfig(!showConfig)
                                                    }}
                                                >
                                                    {showConfig ? "hide config" : "show config"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inline-block align-bottom bg-white dark:bg-gray-800 text-left overflow-hidden shadow transform transition-all w-full sm:w-1/2 sm:mt-3 rounded-none sm:rounded-lg">
                                <div className="bg-white p-5 dark:bg-gray-900">
                                    <div className="sm:flex sm:items-start">
                                        <div className="text-center sm:mt-0 sm:ml-2 sm:text-left w-full">
                                            <h3 className="text-sm leading-6 font-medium text-gray-400"> stripe payment id</h3>
                                            <span className='block w-full'>{paint.payment_intent_id}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inline-block align-bottom bg-white dark:bg-gray-800 text-left overflow-hidden shadow transform transition-all w-full sm:w-1/2 sm:mt-3 rounded-none sm:rounded-lg">
                                <div className="bg-white p-5 dark:bg-gray-900">
                                    <div className="sm:flex sm:items-start">
                                        <div className="text-center sm:mt-0 sm:ml-2 sm:text-left w-full">
                                            <h3 className="text-sm leading-6 font-medium text-gray-400">create by</h3>
                                            <div className="ml-5">
                                                <span className='block w-full'>{paint.user.email}</span>
                                                <span className='block w-full'>{`${paint.user.firstName} ${paint.user.lastName}`}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inline-block align-bottom bg-white dark:bg-gray-800 text-left overflow-hidden shadow transform transition-all w-full sm:w-1/2 sm:mt-3 rounded-none sm:rounded-lg">
                                <div className="bg-white p-5 dark:bg-gray-900">
                                    <div className="sm:flex sm:items-start">
                                        <div className="text-center sm:mt-0 sm:ml-2 sm:text-left w-full">
                                            <h3 className="text-sm leading-6 font-medium text-gray-400 ou">gallery</h3>
                                            {paint.gallery.storages.map((gallery, index) => {
                                                return <div className="ml-5" key={index}>
                                                    <div className='ml-2 mt-3'>
                                                        <h3 className="text-sm leading-6 font-medium text-gray-400">label</h3>
                                                        <input
                                                            value={gallery.label}
                                                            onChange={(event) => {
                                                                const gallery = paint.gallery;
                                                                gallery.storages[index].label = event.target.value;
                                                                setPaint({ ...paint, gallery });
                                                                setSubmit(true)
                                                            }}
                                                            className="text-2xl font-bold text-black dark:text-white dark:bg-gray-800 rounded-lg px-1 w-full"
                                                        />
                                                    </div>
                                                    <div className='ml-6 mt-2'>
                                                        <h3 className="text-sm leading-6 font-medium text-gray-400">max images</h3>
                                                        <input
                                                            type="number"
                                                            value={gallery.max_images}
                                                            onChange={(event) => {
                                                                const gallery = paint.gallery;
                                                                gallery.storages[index].max_images = event.target.valueAsNumber;
                                                                setPaint({ ...paint, gallery });
                                                                setSubmit(true)

                                                            }}
                                                            className="text-2xl font-bold text-black dark:text-white dark:bg-gray-800 rounded-lg px-1 w-full"
                                                        />
                                                    </div>

                                                </div>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="h-10"></div>
                        </div>
                    </form>
                </div>
                :
                <NotFound />
            }
        </div>
    );
};

export default Paint;

export const loader: LoaderFunction = async ({ params }) => {
    const isLog = await isLogin();
    if (!isLog) return redirect(`/login?PaintAdmin=${params.paintId}`);
    const { user } = isLog;
    if (user) {
        const paint = user.paints.find((paint) => paint._id === params.paintId);
        if (paint) {
            return {
                paint,
                ...isLog
            };
        } else {
            return null;
        }
    } else {
        return redirect('/login');
    }
};